module.exports = __webpack_public_path__ + "static/media/portfolio-img-1.844b915c.png";